import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'picksfilter',
    pure: false
})
export class PicksFilter implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(item => item.ngwPlayer.name == filter.name);
    }
}


// WEBPACK FOOTER //
// ./src/pages/rounds/picksFilter.ts